
import { useState, useEffect, useRef } from "react";

const MissionSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-black relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-ophira-yellow/10 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-ophira-yellow/10 to-transparent"></div>
      </div>
      
      <div className="container mx-auto px-4">
        <div className={`text-center max-w-3xl mx-auto transition-all duration-700 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}>
          <h2 className="text-4xl md:text-5xl font-bold mb-12 text-white uppercase tracking-tight">
            OUR MISSION
          </h2>
          
          <p className="text-white/65 text-lg mb-8 leading-relaxed">
            Our mission is to give music makers the freedom to create and be heard. Our growing
            team is made up of left-brained creative technologists, right-brained music professionals
            and everyone in between. We're a family here, and once you join – you're a part of it too.
          </p>
          
          <p className="text-white/65 text-lg leading-relaxed">
            We love music. We love musicians. We're on a mission to provide all creators the access
            and tools to build successful music businesses, enabling our users to thrive while
            preserving their rights and ownership.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
